import { render } from "./HeaderTemplate.vue?vue&type=template&id=274c1af4&scoped=true"
import script from "./HeaderTemplate.vue?vue&type=script&lang=js"
export * from "./HeaderTemplate.vue?vue&type=script&lang=js"

import "./HeaderTemplate.vue?vue&type=style&index=0&id=274c1af4&scoped=true&lang=css"

import exportComponent from "C:\\development\\vueproject\\test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274c1af4"]])

export default __exports__